/**
 * Shared walkthrough steps for all roles.
 * @module features/walkthrough/tours/commonSteps
 */

import { t } from '../i18n/walkthroughI18n';
import { navStep } from './navTourHelpers';

/** @type {import('../walkthroughTypes').WalkthroughStepDef} */
export const WELCOME_STEP = {
  id: 'welcome',
  targetSelector: '[data-walkthrough="welcome-anchor"]',
  title: t('walkthrough.common.welcome.title'),
  body: t('walkthrough.common.welcome.body'),
  placement: 'modal',
};

/** @type {import('../walkthroughTypes').WalkthroughStepDef} */
export const NAV_OVERVIEW_STEP = {
  id: 'nav-overview',
  targetSelector: '[data-walkthrough="nav-sidebar"]',
  mobileSelector: '[data-walkthrough="nav-mobile-menu"]',
  desktopSelector: '[data-walkthrough="nav-sidebar"]',
  title: t('walkthrough.common.nav.title'),
  body: t('walkthrough.common.nav.body'),
  placement: 'right',
};

/** @type {import('../walkthroughTypes').WalkthroughStepDef} */
export const THEME_PROFILE_STEP = {
  id: 'theme-profile',
  targetSelector: '[data-walkthrough="theme-profile"]',
  title: t('walkthrough.common.theme.title'),
  body: t('walkthrough.common.theme.body'),
  placement: 'bottom',
};

export const HELP_FAQS_STEP = navStep('faqs', {
  title: t('walkthrough.common.faqs.title'),
  body: t('walkthrough.common.faqs.body'),
});

export const SIGN_OUT_STEP = navStep('sign-out', {
  title: t('walkthrough.common.signOut.title'),
  body: t('walkthrough.common.signOut.body'),
});

/** @type {import('../walkthroughTypes').WalkthroughStepDef[]} */
export const COMMON_STEPS = [
  WELCOME_STEP,
  NAV_OVERVIEW_STEP,
  THEME_PROFILE_STEP,
  HELP_FAQS_STEP,
  SIGN_OUT_STEP,
];
